/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";
import { PieChartIcon } from "lucide-react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import CustomPieTooltip from "../CustomPieTooltip";

// Default color palette for categories
const DEFAULT_COLORS = [
  "#CE257A", // Primary pink
  "#3B82F6", // Blue
  "#10B981", // Green
  "#F59E0B", // Orange
  "#8B5CF6", // Purple
  "#EC4899", // Pink
  "#14B8A6", // Teal
  "#F97316", // Orange-red
];

const CategoryDistributionChart = ({ data, totalCaregivers }) => {
  const categoryChartData = data.map((cat, index) => ({
    ...cat,
    name: cat.name || cat.category,
    value: cat.count,
    color: cat.color || DEFAULT_COLORS[index % DEFAULT_COLORS.length],
  }));

  return (
    <div className="bg-slate-900 p-4 sm:p-5 rounded-2xl border border-slate-800 shadow-sm text-white">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-bold text-sm sm:text-base">
            Caregiver Categories
          </h3>
          <p className="text-xs text-white/60">
            {totalCaregivers} total caregivers
          </p>
        </div>
        <div className="flex items-center gap-1">
          <span className="text-xs px-2 py-1 bg-slate-700 text-white/70 rounded">
            Time-filtered
          </span>
        </div>
      </div>

      {/* Large Pie Chart */}
      <div className="h-64 sm:h-72">
        {categoryChartData.length > 0 && totalCaregivers > 0 ? (
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={categoryChartData}
                cx="50%"
                cy="50%"
                innerRadius={40}
                outerRadius={80}
                paddingAngle={2}
                dataKey="value"
                labelLine={false}
                isAnimationActive={true}
              >
                {categoryChartData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={entry.color}
                    stroke="transparent"
                    strokeWidth={1}
                  />
                ))}
              </Pie>
              <Tooltip
                content={(props) => (
                  <CustomPieTooltip
                    {...props}
                    totalCaregivers={totalCaregivers}
                  />
                )}
              />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-slate-800 rounded-2xl">
            <div className="text-center">
              <PieChartIcon className="text-white/40 mx-auto mb-2" size={48} />
              <p className="text-white/60 text-sm">
                No caregiver data available
              </p>
            </div>
          </div>
        )}
      </div>

      {/* Category Legend - Compact */}
      <div className="mt-4 grid grid-cols-5 gap-1">
        {categoryChartData.map((cat) => (
          <div
            key={cat.category}
            className="flex flex-col items-center p-1 group cursor-pointer"
            title={`${cat.name}: ${cat.value} caregivers (${Math.round(
              (cat.value / totalCaregivers) * 100,
            )}%)`}
          >
            <div
              className="w-3 h-3 rounded-full mb-1"
              style={{ backgroundColor: cat.color }}
            ></div>
            <p className="text-xs text-white/70 text-center truncate w-full">
              {cat.name.split(" ")[0]}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryDistributionChart;
